module.exports = __webpack_public_path__ + "static/media/pradeep.abcc7479.png";